import React from 'react'
import Text from "../../components/text/Text";
import Colors from "../../styles/Colors";
import Section from "../../components/container/Section";
import styled from "@emotion/styled";

interface Props {
    title?: string,
    children: string,
    imageSrc: string,
    imageRight?: boolean,
}

const AnimalCard = (
    {
        title,
        children,
        imageSrc,
        imageRight = false,
    }: Props
) => {
    const isPhone = window.innerWidth <= 768;
    let textAlign = "left"

    if (isPhone) {
        textAlign = "justify"
    }

    if (imageRight && !isPhone) {
        textAlign = "right"
    }

    return (
        <Section flexDirection={imageRight ? "row-reverse" : "row"}>
            <Image alt={title} src={imageSrc} />

            <ContentContainer>
                {
                    title && <TitleMargin>
                        <Text
                            color={Colors.green}
                            textAlign={isPhone ? "center" : textAlign}
                            type={"h5"}
                        >{title}</Text>
                    </TitleMargin>
                }

                {!!!title && <TextMargin/>}

                <Text textAlign={textAlign}>{children}</Text>
            </ContentContainer>
        </Section>
    )
}

export default AnimalCard

const Image = styled.img`
  width: 20%;
  height: 20%;
  box-shadow: ${Colors.dropdownShadow};
  border-radius: .2%;

  @media (max-width: 768px) {
    width: 90%;
    height: 90%;
  }
`

const TextMargin = styled.div`
  height: 0;
  
  @media (max-width: 768px) {
    height: 25px;
  }
`

const ContentContainer = styled.div`
  width: calc(80% - 40px);
  margin: 0 20px;
  
  @media (max-width: 768px) {
    width: 90%;
    margin: 0;
  }
`

const TitleMargin = styled.div`
   margin-bottom: 20px;

  @media (max-width: 768px) {
    margin-top: 25px;
  }
`
